var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3869 16.4281C14.7349 16.857 15.3646 16.9225 15.7935 16.5745C16.2223 16.2265 16.2879 15.5968 15.9399 15.1679L14.3869 16.4281ZM11.7186 7.67786C11.4268 10.0755 9.2717 11.7677 6.92418 11.482L6.68256 13.4673C10.1461 13.8889 13.2811 11.394 13.704 7.91948L11.7186 7.67786ZM6.92418 11.482C4.57665 11.1963 2.89031 9.03662 3.18211 6.63896L1.19676 6.39735C0.773909 9.87185 3.21903 13.0458 6.68256 13.4673L6.92418 11.482ZM3.18211 6.63896C3.47391 4.2413 5.62902 2.54914 7.97654 2.83484L8.21816 0.849486C4.75463 0.427972 1.61961 2.92284 1.19676 6.39735L3.18211 6.63896ZM7.97654 2.83484C10.3241 3.12053 12.0104 5.2802 11.7186 7.67786L13.704 7.91948C14.1268 4.44497 11.6817 1.271 8.21816 0.849486L7.97654 2.83484ZM10.0055 11.0289L14.3869 16.4281L15.9399 15.1679L11.5585 9.76869L10.0055 11.0289Z",
    fill: "#B3BEC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.367ab32ecfb569cd06d92b1430d9168c.svg";
export { ForwardRef as ReactComponent };